import type { Ref } from 'preact';
import VideoPlayer from '../../../VideoPlayer/VideoPlayer.tsx';
import styles from './Video.module.scss';

export type VideoProps = {
  url: string;
  noVideoSupportLabel: string;
  playPauseButtonLabel: string;
  hasReducedMotion: boolean;
  autoPlay?: boolean;
  ref?: Ref<HTMLVideoElement>;
};
export default function Video({
  url,
  noVideoSupportLabel,
  playPauseButtonLabel,
  hasReducedMotion,
  autoPlay,
  ref
}: VideoProps) {
  return (
    <VideoPlayer
      ref={ref}
      source={[
        {
          url,
          type: 'video/mp4'
        }
      ]}
      translations={{
        noVideoSupportLabel,
        playPauseButtonLabel
      }}
      autoPlay={autoPlay}
      hasReducedMotion={hasReducedMotion}
      class={styles.videoContainer}
    />
  );
}
